import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './css/animate.min.css';
// import './css/bootstrap.min.css';
import './css/datepicker.css';
import './css/font-awesome.min.css';
import './css/magnific-popup.css';
import './css/nice-select.css';
import './css/normalize.css';
import './css/owl-carousel.css';
import './css/responsive.css';
import './css/slicknav.min.css';
import './css/color1.css';
import './css/style.css';
import './css/icofont.css';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
